// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import fields from './view/StatFiles';
import ListView from '../view/View';
import { useParams, Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import BackIcon from '@material-ui/icons/ArrowBack';



export default function Signs(props) {
	//Inherited props
  	const {handleSend, user, organization} = props;
    //path props
    const { id } = useParams();
	//control loading from server
  	const [loaded, setLoaded] = React.useState(false);
    //loaded status
    const [loadComplete, setLoadComplete] = React.useState(false);
	//list of signs unfiltered
  	const [fileList, setFileList] = React.useState([]);
	//default view
  	const defaultView = {
		id : 0,
		lv_name : 'All Files',
		lv_table : 'spl_queue',
		lv_fields : [
			{
        		name : 'entry_date'
    		}, {
        		name : 'active'
    		}, {
        		name : 'finish_date'
    		}, {
        		name : 'path'
    		}, {
        		name : 'size'
    		}
		],
		lv_filter : {
			type : 'AND',
			custom : '',
			conditions : []
		},
		lv_sort : [],
		sharing : 'private'
  	};
	
	//on state change
  	React.useEffect(() => {
		//if signs have not been loaded from UI yet
		if(!loaded){
			getFileList();
		}
	});
	//get signs from server
  	const getFileList = () =>{
		setLoaded(true);
	  	handleSend({
		  	vso: 'stats',
            sign: id,
            subaction: 'listfiles',
	  	}, (data) => {
            setLoadComplete(true);
		  	setFileList(data.stats);
	  	});
  	}



	//compile result in ListView
    if(!loadComplete) return Array.apply(null, Array(50)).map((e, i) => (<Skeleton variant='rect' style={{marginTop: 3}} key={i} height={57} />));
	return (
		<div>
			<Button startIcon={<BackIcon />} component={Link} to={['/sign', id, 'stats'].join('/')}>Back to Stats</Button>
		<ListView 
			label="Stats Files"
			user={user} 
			organization={organization} 
			handleSend={handleSend} 
			fields={fields} 
			items={fileList} 
			defaultView={defaultView} />
		</div>
	);
}
